// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Legends_wrap__yOAV1","legend":"Legends_legend__1KCmG","rectangle":"Legends_rectangle__2uyvx","label":"Legends_label__2KDF_"};